export default {

  levels: [],

  labels: [],

  countries: [],
  provinces: [],
  cities: [],
  regions: [],

  banks: [],

  vendorCategory: [],
  vendors: [],

  customers: [],

};
